module.exports = __webpack_public_path__ + "img/telsam-logo.e924c3fb.png";